<template>
    <div class="box-build">
        <div class="box-head">
            <div class="head-logo">
                <div class="logo-con">
                    <img :src="header.logoPhoto" style="height:100%;" />
                </div>
                <!-- <p>{{header.platformName}}</p> -->
            </div>
            <img class="head-img" :src="header.headR" />
        </div>
        <div class="head-menu">
            <div class="head-menu-box">
                <div class="head-menu-item" v-for="item in items" :key="item.id" :class="{'curFirstMenu':item.id==menu.firstMenu.id}" @click="firstMenuFun(item)">
                    <div class="item-box">
                        <!-- <img :src="item.icon" style="height:38.5%;" v-if="item.icon && item.icon!=''" />
                        <i v-else class="el-icon-menu" style="font-size:2vh;margin: 0.3vh;"></i> -->
                        <p style="width:100%;font-size:1vw;padding: 5%;">{{item.name}}</p>
                    </div>
                </div>
            </div>
            <div class="head-Info">
                <div class="head-pro" v-if="showProList.length==1">
                    <p class="nowrap pro-name" style="width:100%;" :title="groupName">{{groupName}}</p>
                </div>
                <div class="head-pro" v-else>
                    <el-popover
                        placement="bottom"
                        width="300"
                        trigger="click"
                        popper-class="popover-fat"
                    >
                        <div class="popover-box">
                            <p class="popover-box-p">
                                <el-input
                                    placeholder="请输入企业名称"
                                    suffix-icon="el-icon-search"
                                    @input="proNameFun"
                                    style="max-width:100%;"
                                    v-model="project.name">
                                </el-input>
                            </p>
                            <p v-if="showProList.length==0" class="popover-box-p nowrap addPad" style="text-align: center;">暂无数据</p>
                            <p v-for="item in showProList" :key="item.id" class="popover-box-p nowrap addPad" :title="item.groupName" :class="{'curPro':item.groupId==groupId}" @click="selctPro(item)" >
                                {{item.groupName}}
                            </p>
                        </div>
                        <div slot="reference" style="width:100%;display:flex;">
                            <p class="nowrap pro-name" @click="showProject" :title="groupName">{{groupName}}</p>
                            <i class="el-icon-caret-bottom" @click="showProject" style="color:#fff;font-size:1vw;"></i>
                        </div>
                    </el-popover>
                </div>
                <div class="head-user">
                    <el-popover placement="bottom" width="170" trigger="click" style="width:100%;" popper-class="popover-info">
                        <div class="myPersonal">
                        <div
                            v-for="(item, index) in arr"
                            :key="index"
                            @click="selected(item.act)"
                        >{{ item.name }}
                        <span v-if="item.act==1" style="color: #0490F9;">{{dealtCount.wfq}}</span>
                        <span v-if="item.act==2" style="color: #f00;">{{dealtCount.dcl}}</span>
                        <span v-if="item.act==3" style="color: rgb(53, 179, 120);">{{dealtCount.ycl}}</span>
                      </div>
                        </div>
                        <div slot="reference" class="head-user-con" @click="visiblePro=false,visiblePort=false" style="justify-content: center;">
                          <div v-if="dealtCount.dcl!=0" class="unmessage">{{dealtCount.dcl}}</div>
                          <!-- <i class="el-icon-user-solid" style="background:#3B5998;color:#ffffff;font-size: 1.6vw;border-radius: 50%;"></i> -->
                            <div style="width:3vh;height:3vh;position: relative;background: #fff;border-radius: 50%;">
                                <img src="../../assets/image/drop.png" style="width: 1.8vh;;position: relative;" />
                            </div>
                            <span style="padding-left:5%;">{{loginName}}</span>
                        </div>
                    </el-popover>
                </div>
                <div v-if="portList.length>1" style="position: relative;height:100%;display: flex;align-items: center;">
                    <el-popover
                        placement="bottom"
                        width="100"
                        trigger="click"
                        popper-class="popover-fat"
                    >
                        <div class="popover-box" style="width:5vw;">
                            <p v-for="item in portList" :key="item.id" :class="{'curPro':item.userType==port}" @click="selectPort(item)" class="popover-box-p nowrap addPad">
                                {{item.userTypeName}}
                            </p>
                        </div>
                        <div slot="reference" style="width:100%;display:flex;">
                            <i class="el-icon-caret-bottom" slot="reference" style="color:#fff;font-size:1vw;cursor: pointer;"></i>
                        </div>
                    </el-popover>
                </div>
                <div v-if="groupId=='1263382107619520513'" style="position: relative;height:100%;display: flex;align-items: center;color:rgb(12 228 78);width:120px;justify-content: center;">
                    在线 {{logCount}}
                </div>
            </div>
        </div>
        <div class="box-main">
            <el-menu :default-active="menu.secMenu.id" class="el-menu-vertical-demo" @select="selMenu" :collapse="isCollapse" v-if="secondMenu.length>0" style="background: #E5E5E5;overflow-y: auto;overflow-x: hidden;">
                <el-menu-item index="-1">
                    <div style="width:100%;">
                        <i v-if="isCollapse" class="el-icon-menu"></i>
                        <i v-else class="el-icon-more"></i>
                    </div>
                </el-menu-item>
                <template v-for="item in secondMenu">
                    <el-submenu :key="item.id" v-if="item.isChild" :index="item.id">
                        <template slot="title">
                            <i v-if="item.icon == ''" class="el-icon-document"></i>
                            <img v-else :src="item.icon" class="el-icon-other" style="max-width:30px;max-height:30px;margin-right: 10px;" />
                            <span>{{item.name}}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-for="child in item.children" :key="child.id" :index="child.id">
                                <div style="width:100%;text-align: left;" @click="pageMenu(child)">
                                    <i v-if="child.icon == ''" class="el-icon-document"></i>
                                    <img v-else :src="child.icon" class="el-icon-other" style="max-width:30px;max-height:30px;margin-right: 10px;" />
                                    <span slot="title"> {{ child.name }}</span>
                                </div>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item :key="item.id" v-else :index="item.id"  :class="{'sec-menu':item.id==menu.secMenu.id}">
                        <div style="width:100%;text-align: left;" @click="pageMenu(item)">
                            <i v-if="item.icon == ''" class="el-icon-document"></i>
                            <img v-else :src="item.icon" class="el-icon-other" style="max-width:30px;max-height:30px;margin-right: 10px;" />
                            <span slot="title"> {{ item.name }}</span>
                        </div>
                    </el-menu-item>
                </template>
            </el-menu>
            <div class="box-main-con" :class="{'toSmall':isCollapse,'toAll':secondMenu.length==0}">
                <router-view></router-view>
            </div>
        </div>
        <el-dialog
            title="修改密码"
            :visible.sync="dialogVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
            >
            <el-form
                :model="ruleForm"
                status-icon
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="原密码" prop="oldPass">
                <el-input type="password" v-model="ruleForm.oldPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="pass">
                <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../untils/util';
import myHttp from '../../untils/port';
import base from '../../untils/base';
export default {
    data() {
        var validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入新密码'))
        } else {
            if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass')
            }
            callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请再次输入密码'))
        } else if (value !== this.ruleForm.pass) {
            callback(new Error('两次输入密码不一致!'))
        } else {
            callback()
        }
      }
      return {
        isCollapse: false,
        isShow:false,
        visiblePro:false,//项目选择
        visiblePort:false,//端选择
        project:{
            name:'',
        },
        showProList:[],
        groups:[],
        groupId:'',
        groupName:'',
        portList:util.session.get('role')||[],
        port:'3',//当前端
        items:[],//菜单
        menu:{
            firstMenu:{},//一级菜单
            secMenu:{},//二级菜单
        },
        secondMenu:[],//二级菜单
        arr: [
            { name: '我发起的', act: '1' },
            { name: '我未处理', act: '2' },
            { name: '我已处理', act: '3' },
            { name: '修改密码', act: '4' },
            { name: '退出', act: '5' }
        ],
        hoverIndex: -1, // 菜单hover索引
        activeLinkId: 0, // 当前激活的菜单id
        loginName:'',
        defaultImg:require('../../../public/image/logo1.png'),
        defaultHeadR : require('../../assets/image/cnt-top-r.png'),
        header: {
            headR:'',
            logoPhoto: '',
            platformName: '祯昕施工数字管理平台'
        },
        dialogVisible:false,
        ruleForm: {
            oldPass: '',
            pass: '',
            checkPass: ''
        },
        rules: {
            pass: [{ validator: validatePass, trigger: 'blur' }],
            checkPass: [{ validator: validatePass2, trigger: 'blur' }]
        },
        onlineTimes:undefined,
        logCount:0, //当前人
        dealtCount:{
          dcl: 0,
          wfq: 0,
          ycl: 0,
        },
      }
    },
    watch:{
        '$store.state.firstMenu':function(val,old){
            var list = this.items
            if(val=='')return;
            for(var i=0;i<list.length;i++){
                if(list[i].isChild){
                    //var strs = list[i].children
                    for(var j=0;j<list[i].children.length;j++){
                        var str = list[i].children[j].href
                        if(val==str||('/'+val)==str){
                            // this.menu.firstMenu.id = list[i].id
                            this.firstMenuFun(list[i])
                        }
                    }
                }else{
                    var str = list[i].href
                    if(val==str||('/'+val)==str){
                        // this.menu.firstMenu.id = list[i].id
                        this.firstMenuFun(list[i])
                    }
                }
            }
        }
    },
    mounted(){
        if(!util.session.get('token')||util.session.get('token')==''){
            this.$router.replace('/loginTs')
            return;
        }
        this.setGroupList()
        this.loginName = util.session.get('user') && util.session.get('user').name
        util.session.set('roleId',this.port)
        if(this.onlineTimes){
            window.clearTimeout(this.onlineTimes)
        }
        this.userLogin()
    },
    methods: {
        //二级菜单选择
        selMenu(index,path){
            if(index==-1){
                this.isCollapse = !this.isCollapse
            }
        },
        showProject(){
            this.visiblePro = !this.visiblePro
            this.project.name = ''
            this.showProList = this.groups
            this.visiblePort = false
        },
        //选择项目
        selctPro(obj){
            this.groupId = obj.groupId
            this.groupName = obj.groupName
            this.visiblePro = false
            util.session.set('groupId',this.groupId )
            this.$store.commit('setGroupId')
            this.getMenu()
            this.$router.go(0)
            this.project.name = ''
            this.showProList = this.groups
            this.getQsDealtCount()

        },
        //选择端
        selectPort(obj){
            // if(this.port != obj.userType){
            //     this.port = obj.userType
            //     util.session.set('roleId', this.port)
            //     this.$store.commit('getRoleId')
            //     util.session.remove('curMenu')
            //     this.setGroupList(1)
            // }
            if(this.port == obj.userType)return;
            util.session.set('roleId', obj.userType)
            util.session.remove('curMenu')
            util.session.remove('groupId')
            this.$store.commit("setGroupId")
            this.$store.commit("getRoleId")
            if(obj.userType=='4'){
                this.$router.push({ name: 'homeAll' })
            }else if(obj.userType=='5'){
                this.$router.push({ name: 'comHome' })
            }
        },
        //获取项目
        setGroupList(flag){
            var oldGroupId = util.session.get('groupId')  //用于判断海恒是否返回首页
            var userId = util.session.get('user')&&util.session.get('user').id || ''
            var userType = this.port
            var that = this
            myHttp.getGroupListByUserId({
                userId: userId,
                userType: userType
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data
                    if (that.port == '3') {
                        //企业端 - 数据
                        that.groups = data.entList || []
                    } else if (that.port == '4') {
                        //项目端 - 数据
                        that.groups = data.projectList || []
                    } else if (that.port == '2') {
                        //监管端
                        that.groups = data.supList || []
                    } else if (that.port == '5') {
                        //施工端 - 数据
                        that.groups = data.constructList || []
                    }
                    // that.groups = data.groupList||[]
                    that.showProList = that.groups
                    that.$store.commit('setProject', that.groups)
                    //获取当前企业或者项目id
                    if ( undefined == that.$store.state.groupId || that.$store.state.groupId == '' ) {
                        that.groupId = that.groups.length > 0 ? that.groups[0].groupId : ''
                        that.groupName = that.groups.length > 0 ? that.groups[0].groupName : ''
                    } else {
                        that.groupId = that.idFilter( that.$store.state.groupId, that.groups )
                        that.groupName = util.common.getNameByList(util.session.get('groupId'),that.groups,'groupId','groupName')
                    }
                    var info = that.infoFilter(that.$store.state.groupId, that.groups)
                    that.header.headR = info.entPhoto && info.entPhoto != '' ? base.httpCtx + info.entPhoto : that.defaultHeadR
                    that.header.logoPhoto = info.logoPhoto && info.logoPhoto != '' ? base.httpCtx + info.logoPhoto : that.defaultImg
                    that.header.platformName = info.platformName && '' != info.platformName ? info.platformName : '祯昕施工数字管理平台'
                    util.session.set('groupId', that.groupId)
                    that.$store.commit('setGroupId')
                    that.getMenu()
                    that.getQsDealtCount()
                    if (that.port == '5' && flag == 1) {
                        //施工方企业端 - 跳转
                        setTimeout(function() {
                            that.$router.push({ name: 'conproTotal' })
                        }, 100)
                    } else if (that.port == '3') {
                        //建设方企业端
                        setTimeout(function() {
                        if(that.groupId=='1214807566895210497' && flag == 1){
                            that.$router.push({ name: 'homeHai' })
                        }else if(flag == 1){
                            that.$router.push({ name: 'stateData' })
                        }
                        }, 100)
                    } else if (that.port == '4' && flag == 1) {
                        //项目端 - 跳转
                        setTimeout(function() {
                            that.$router.push({ name: 'homeAll' })
                        }, 100)
                    }
                } else {
                    that.$message.error(resp.data.msg)
                }
                },function() {}
            )
        },
        //根据id获取数据
        infoFilter(id, list) {
            var result =
                list && list.length > 0
                ? list[0]
                : {
                    id: '',
                    logoPhoto: this.defuleImg,
                    platformName: '祯昕施工数字管理平台'
                    }
            for (var i = 0; i < list.length; i++) {
                if (id == list[i].groupId) {
                result = list[i]
                }
            }
            return result
        },
        //判断是否属于user
        filter(id,list,str){
            var result = false
            if(list.length>0){
                for(var i=0;i<list.length;i++){
                    if(list[i][str]==id){
                        result = true
                    }
                }
            }
            return result
        },
        //当前id是否是项目List里
        idFilter(id, list) {
            var result = list && list.length > 0 ? list[0].groupId : ''
            for (var i = 0; i < list.length; i++) {
                if (id == list[i].groupId) {
                  result = id
                }
            }
            return result
        },
        //获取菜单
        getMenu(){
            var userId = (this.$store.state.user && this.$store.state.user.id) || ''
            var userType = this.port
            var groupId = this.groupId
            var that = this
            myHttp.getMenuList({
                userId: userId,
                userType: userType,
                groupId: groupId
            }).then( function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.menuList
                    var filter = []
                       var btnMneu = []
                    for (var i = 0; i < list.length; i++) {
                        if (list[i].type == '2') {
                        list[i].href = '' == list[i].href ? '#' : list[i].href
                        list[i].icon ='' == list[i].icon || undefined == list[i].icon ? '': base.httpCtx + list[i].icon
                        list[i].icon2 ='' == list[i].icon2 || undefined == list[i].icon2 ? '': base.httpCtx + list[i].icon2
                        filter.push(list[i])
                        }else if(list[i].type == '3'){
                            btnMneu.push(list[i])
                        }
                    }
                     that.$store.commit('setBtnMenu',btnMneu)
                    list = util.common.listToTree('id', 'parentId', filter)
                    that.items = list
                    that.setSeconMenuFun()
                } else {
                    that.$message.error(resp.data.msg)
                }
            },
            function() {}
            )
        },
        //设置二级菜单（初始化）
        setSeconMenuFun(){
            this.menu = util.session.get('curMenu')
            if(!this.menu){
                this.menu = {firstMenu:{id:this.items[0].id}}
                if(this.items[0].children>0){
                    this.secondMenu = this.items[0].children
                    this.menu.secMenu = {id:this.items[0].children[0].id}
                }
            }else if(this.menu.secMenu && this.menu.secMenu.id!=''){
                this.secondMenu = util.common.getNameByList(this.menu.firstMenu.id,this.items,'id','children')||[]
            }
            this.isShow = true
        },
        //项目过滤
        proNameFun(val){
            if(val==''){
                this.showProList = this.groups
            }else{
                this.showProList = []
                var list = []
                for(var i=0;i<this.groups.length;i++){
                    if(this.groups[i].groupName.indexOf(val)>-1){
                        this.showProList.push(this.groups[i])
                    }
                }
            }
        },
        //一级菜单点击方法
        firstMenuFun(obj){
            //console.log(obj.children)
            this.$store.commit('setFirstMenu', '')
            this.menu.firstMenu = {id:obj.id}
            if(obj.children && obj.children.length>0){
                this.secondMenu = obj.children
                this.menu.secMenu = obj.children[0]
                if(obj.children[0].target =='_blank'){
                    let routeUrl = this.$router.resolve({
                        path: obj.children[0].href
                    });
                    window.open(routeUrl .href, '_blank');
                }else{
                    this.$router.push({ path: obj.children[0].href })
                }
            }else if(obj.href=='/project'){
                this.secondMenu = [
                    {name:'项目概况',href:'/project',id:'202007001'},{name:'劳务统计',href:'/labor',id:'202007002'},{name:'班组考勤',href:'/infoTeam',id:'202007003'}
                   ,{name:'人员信息',href:'/person',id:'202007004'},{name:'劳务合同',href:'/agreePro',id:'202007005'},{name:'数据上传',href:'/dataUp',id:'202007006'}
                   ,{name:'质量安全',href:'/safety',id:'202007007'},{name:'扬尘监测',href:'/dust',id:'202007008'},{name:'项目塔吊',href:'/tower',id:'202007009'}
                   ,{name:'升降机',href:'/liftPro',id:'202007010'},{name:'项目监控',href:'#',id:'202007011'},{name:'不良记录',href:'/badPro',id:'202007012'}
                   ,{name:'专户申报',href:'/wagePro',id:'202007013'}
                ]
                this.menu.secMenu = obj.children[0]
            }else{
                this.secondMenu = []
                if(obj.target=='_blank'){
                    let routeUrl = this.$router.resolve({
                        path: obj.href
                    });
                    window.open(routeUrl .href, '_blank');
                }else{
                    this.$router.push({ path: obj.href })
                }
            }
            util.session.set('curMenu', this.menu)
            this.isShow = true
        },
        //二级菜单点击方法
        pageMenu(obj){
            this.$store.commit('setFirstMenu', '')
            if(obj.href=='/snap'){
                var projectId = this.groupId;
                let routeUrl = this.$router.resolve({
                    name: "attendShoot",
                    params: {'id': projectId}
                });
                window.open(routeUrl .href, '_blank');
            }else{
                this.menu.secMenu = {id:obj.id}
                util.session.set('curMenu', this.menu)
                this.$router.push({ path: obj.href })
            }
        },
        //点击我的
        selected(stu) {
            if (stu == 0) {
                if ( !this.personId || this.personId == 'undefined' || '' == this.personId ) {
                    this.$message.error('当前账号未在项目采集实名')
                    return
                }
                this.$router.push({ name: 'perFile', params: { id: this.personId } })
                this.dialogVisible = false
            }
            if (stu == 4) {
                this.dialogVisible = true
            }else if(stu == 5){
                var type = util.session.get('type')
                // console.log(type)
                util.session.clear()
                this.$store.commit('getToken')
                this.$store.commit('setUser')
                this.$store.commit('setGroupId')
                this.$store.commit('getRoleId')
                this.$store.commit('getRole')
                // this.$router.push({ name: 'loginTs' })
                var that = this
                setTimeout(function() {
                    // if (type == '1') {
                    // that.$router.push({ name: 'loginHgd' })
                    // } else if (type == '2') {
                    // that.$router.push({ name: 'loginHh' })
                    // } else if (type == '3') {
                    // that.$router.push({ name: 'loginBh' })
                    // } else if (type == '4') {
                    // that.$router.push({ name: 'loginJk' })
                    // } else {
                    // that.$router.push({ name: 'loginTs' })
                    // }
                    if (type == '1') {
                        that.$router.push({ name: 'loginHgd' })
                    }else if(type=='6'){
                        that.$router.push({name:'loginGZ'})
                    }else if(type=='7'){
                        that.$router.push({name:'loginGx'})
                    }else if(type=='-1'){
                        window.location.href = 'http://47.103.123.116:18005/loginTs'
                    }else {
                        that.$router.push({ name: 'loginTs' })
                    }
                }, 100)
            }else if(stu == 1||stu==2 ||stu==3){
                  this.$router.push({ name: 'mybuildQs',params:{type: stu}})
                }
        },

        //提交修改密码
        submitForm(formName) {
            var that = this
            var userId = util.session.get('user').id || ''
            this.$refs[formName].validate(valid => {
                if (valid) {
                    myHttp.getUpdatePassWord({
                        id: userId,
                        oldPassWord: this.ruleForm.oldPass,
                        newPassword: this.ruleForm.pass
                    }).then(function(resp) {
                            if (resp.data.code == '200') {
                                that.$message.success('修改密码成功')
                                that.dialogVisible = false
                            } else {
                                that.$message.error(resp.data.msg)
                            }
                    },function() {})
                } else {
                    return false
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },

        //定时刷新登录
        userLogin(){
            var that = this
            myHttp.webLoginTiming({
                userId:util.session.get('user').id
            }).then(function(resp){
                that.onlineTimes = setTimeout(function(){
                    that.userLogin()
                },180000)
                that.getCurLogNum()
            })
        },
        //获取当前人数
        getCurLogNum(){
            var that = this
            myHttp.selectOnlinePersonCount({
                entId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.logCount = resp.data.data.count||0
                }
            })
        },
           /***
         * 获取未处理数量
        */
        getQsDealtCount(){
          let that = this
          myHttp
            .getQsEntDealtCount({
              entId : this.groupId,
              userId: util.session.get('user').id,
              joinType:'3'
            })
            .then(function(resp) {
              if (resp.data.code == '200') {
                if (resp.data.code == '200') {
                var data = resp.data.data.dealtCount || []
                }
                that.dealtCount = data
              }
              // that.projects = list
            })
        }
    }
}
</script>
<style scoped>
    .box-build{
        width: 100%;
        height: 100vh;
        position: relative;
    }
    .box-head{
        width: 100%;
        height: 10.5vh;
        position: relative;
        /* background: #fff; */
        display: flex;
        justify-content: space-between;
        background-image: linear-gradient(#76ADE6, #B5D5FD);
    }
    .head-logo{
        /* width: 10%; */
        flex: 1;
        height: 100%;
        position: relative;
        display: flex;
        /* justify-content: center;
        justify-items: center; */
        align-content: center;
        align-items: center;
        padding-left: 2vw;
        /* background: #76ADE6; */
        /* flex-wrap: wrap; */
    }
    .logo-con{
        /* width: 30%; */
        height: 80%;
        position: relative;
        padding: 0.4vh;
        /* background: #fff; */
        border-radius: 5px;
    }
    .head-logo p{
        flex: 1;
        position: relative;
        font-size: 2.2vw;
        /* text-shadow:#0847a5 2px 3px 10px; */
        color:white;
        text-align: left;
        padding-left: 1vh;
        -webkit-text-stroke: 2px #3469B7;
        text-stroke: 2px #3469B7;
        line-height:1;
    }
    .head-img{
        /* width: 30vw; */
        height: 100%;
        position: relative;
        padding-right: 5vw;
    }
    .head-menu{
        width: 100%;
        height: 5.5vh;
        position: relative;
        display: flex;
        /* background: linear-gradient(to right, #0490F9, #0028E8); */
        background: #003D9C;
    }
    .head-menu-box{
        flex:1;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
    }
    .head-menu-item{
        width: 15%;
        height: 100%;
        position: relative;
        padding: 0 1%;
        /* padding: 0.5% 1%; */
    }
    .item-box{
        width: 100%;
        height: 100%;
        position: relative;
        /* background: cornsilk; */
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        justify-items: center;
        border-radius: 4px;
        align-content: center;
        align-items: center;
        cursor: pointer;
        color: #fff;
    }
    .head-Info{
        width: 30%;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        /* background: #0028E8; */
        padding-right: 2vw;
    }
    .head-Info p,.head-Info span{
        color: #fff;
    }
    .head-pro{
        width: 60%;
        height: 100%;
        position: relative;
        font-size: 0.8vw;
        color: #235182;
        display: flex;
        align-content: center;
        align-items: center;
        padding-right: 3%;
        cursor: pointer;
    }
    .head-pro>span{
        width: 100%;
    }
    .head-pro .pro-name{
        width: 90%;
        /* height: 100%; */
        text-align: right;
    }
    .head-user{
        width: 30%;
        height: 100%;
        position: relative;
        font-size: 0.8vw;
        color: #235182;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1%;
    }
    .head-user-con{
        width: 100%;
        display: flex;
        align-content: center;
        align-items: center;
        /* justify-content: center; */
        cursor: pointer;
    }

    .box-main{
        width: 100%;
        height: 84vh;
        position: relative;
        display: flex;
        /* overflow: hidden; */
    }
    .box-main-con{
        /* flex: 1; */
        width: 89.6vw;
        height: 100%;
        position: relative;
        background: #ecf0f5;
    }
    .toSmall{
        width: 96.27vw;
    }
    .toAll{
        width: 99.6vw;
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 10vw;
        min-height: 400px;
        
    }
    .el-menu-item{
        display: flex;
        align-items: center;
        align-content: center;
    }
    /* .box-main-left{
        width: auto;
    } */
    /* .box-main-left:not(.collapse){
        width: 10%;
        height: 100%;
        position: relative;
        overflow: auto;
    }
    .box-main-left:has(.collapse){
        width: 3%;
        height: 100%;
        position: relative;
        overflow: auto;
    } */
    .el-menu--collapse{
        width: 3.33vw;
    }
    
    .popover-box{
        width:16vw;
        height: auto;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        max-height: 50vh;
        overflow: auto;
    }
    .popover-box-p{
        /* width: 100%; */
        height: 5vh;
        line-height: 4vh;
        cursor: pointer;
        text-align: center;
        width: 16vw;
    }
    .popover-box-p:hover{
        color: blue;
        background: rgba(64, 158, 255, 0.5);
    }
    .addPad{
        padding: 2%;
    }
    .curPro{
        color: blue;
    }
    .curFirstMenu .item-box{
        background: #2566C0;
        border-radius: 0;
        /* color: #0028E8; */
    }
    /* .curFirstMenu p{
        color: #0028E8;
    } */
    .sec-menu,.el-menu-item:hover{
        background: #fff;
        border-left: 5px solid #235182;
    }
    .el-menu-item:nth-child(1):hover{
        border: 0;
        background: inherit;
    }
    .popover-info{
        padding: 5%;
    }
    .myPersonal {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .myPersonal > div {
        padding: 5%;
        cursor: pointer;
    }
    .myPersonal > div:hover{
        color:#0028E8
    }
    .el-menu-item-group .is-active{
        background: #fff;
        border-left: 5px solid #235182 ;
    }
</style>
<style>
    .el-menu-item-group__title{
        display: none;
    }
    .el-menu{
        background: transparent;
    }
    .popover-fat{
        padding: 0;
        min-width:fit-content;
    }
    .popover-fat .el-input__inner{
        border-top: 0;
        border-radius: 0;
        border-left: 0;
        border-right: 0;
        height: 5vh;
    }
    .unmessage{
      position: absolute;
      background: #f00;
      color: #fff;
      border-radius: 50%;
      z-index: 1000;
      padding: 4px;
      left: 28px;
      top: -15px;
      font-size: 10px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    /* .el-menu-item-group>ul{
        background: rgba(0, 0, 0, 0.1)
    } */
    @import '../../assets/css/common.css';
</style>